import type { ReactNode } from 'react';

import { Card } from '../../components/ui/Card';
import { brand } from '../../config/brand';

/** The narrow centred frame every auth screen shares. */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="mx-auto flex max-w-md flex-col gap-6 px-6 py-16">
      <div className="flex flex-col items-center gap-3 text-center">
        <img src={brand.logoMark} alt="" className="h-11 w-11" />
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-soft">{subtitle}</p>}
      </div>

      <Card className="p-6">{children}</Card>

      {footer && <div className="text-center text-sm text-soft">{footer}</div>}
    </div>
  );
}
